import React from 'react';
import { Lightbulb } from 'lucide-react';

export const InlineTip = ({ title = 'Why this matters', children }) => (
  <div className="rounded-lg border border-lime/30 bg-lime/5 p-4 flex gap-3 text-left" data-testid="inline-tip">
    <Lightbulb size={18} className="text-lime shrink-0 mt-0.5" />
    <div>
      <p className="text-lime text-xs font-bold uppercase tracking-wide mb-1">{title}</p>
      <p className="text-sm text-light-gray leading-relaxed">{children}</p>
    </div>
  </div>
);
